module.exports = __webpack_public_path__ + "img/opera-icon.123341a4.png";